module.exports = __webpack_public_path__ + "img/G3.5354feff.jpg";